import React from 'react';
import styled from 'styled-components';
import {
  FormGroup,
  FormControl,
  InputGroup,
  Button,
} from 'react-bootstrap';

const ThisInputGroup = styled(InputGroup)`

  span {
    border-radius: 0;
  }

  input {
    padding: 21px 14px;
    border-radius: 0;
  }

  .input-group-btn {
    width: 100%;
    float: left;

    @media (min-width: 1200px) {
      width: auto;
      float: none;
    }
  }

  button {
    width: 100%;
    border-radius: 0;
    background-color: #00ad83;
    color: white;
    font-weight: 700;
    padding: 12px 20px;
    font-size: 13px;
  }
`;

const BidOnAuctionFormUI = ({
  handleSubmit,
  bidValue,
  handleBidAmountChange,
}) => (
  <form autoComplete="off" onSubmit={handleSubmit}>
    <FormGroup controlId="bidAbmount">
      <ThisInputGroup>
        <FormControl
          type="text"
          pattern="[0-9\.]*"
          placeholder="Bid Amount"
          value={bidValue}
          onChange={handleBidAmountChange}
        />
        <InputGroup.Button>
          <Button type="submit">Place Bid</Button>
        </InputGroup.Button>
      </ThisInputGroup>
    </FormGroup>
  </form>
);

export default BidOnAuctionFormUI;



// WEBPACK FOOTER //
// ./src/components/ui/BidOnAuctionFormUI.js